import React from 'react';

const WorkIcon: React.FC<{className?: string}> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path fillRule="evenodd" d="M7.5 5.25A2.25 2.25 0 0 1 9.75 3h4.5a2.25 2.25 0 0 1 2.25 2.25v.75a.75.75 0 0 1-1.5 0v-.75a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v.75a.75.75 0 0 1-1.5 0v-.75Zm-3.75 3A2.25 2.25 0 0 1 6 6h12a2.25 2.25 0 0 1 2.25 2.25v10.5A2.25 2.25 0 0 1 18 21H6a2.25 2.25 0 0 1-2.25-2.25V8.25Zm.75 1.5v9.75a.75.75 0 0 0 .75.75h12a.75.75 0 0 0 .75-.75V9.75a.75.75 0 0 0-.75-.75H4.5a.75.75 0 0 0-.75.75Z" clipRule="evenodd" />
    </svg>
  );
};

export default WorkIcon;
